import { Component, type ErrorInfo, type ReactNode } from 'react'
import { ErrorState } from '@/components/common/StateViews'

interface Props {
  children: ReactNode
}

interface State {
  error: Error | null
}

/** Last line of defence: keeps a render error from blanking the whole app. */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ui] Unhandled render error', error, info.componentStack)
  }

  render() {
    if (this.state.error) {
      return (
        <div className="mx-auto max-w-lg p-6">
          <ErrorState
            title="This screen crashed"
            message={this.state.error.message}
            onRetry={() => this.setState({ error: null })}
          />
        </div>
      )
    }
    return this.props.children
  }
}
